<template>
  <div id="pageTable" class="subView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">기사 상세 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                :headers="detailComplex.headers"
                :items="detailComplex.items"
                hide-actions
                class="elevation-1"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">
                    <div class="text-mixed">
                      <v-layout align-center class="ma-0">
                        <v-text-field
                                placeholder="이름"
                                v-model="props.item.name"
                        ></v-text-field>
                        <v-btn color="warning" small dark @click="changeDriverName(props.item)">수정</v-btn>
                      </v-layout>
                    </div>
                  </td>
                  <td class="text-sm-center">{{ props.item.personalInfo.birthDay }}</td>
                  <td class="text-sm-center">{{ props.item.personalInfo.gender === 'M' ? '남자' : '여자' }}</td>
                  <td class="text-sm-center">{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.state }}</td>
                  <td class="text-sm-center">{{ props.item.usageCount }}</td>
                  <td class="text-sm-center">{{ props.item.totalFee }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                </template>
              </v-data-table>
              <v-divider></v-divider>
              <v-data-table
                :headers="detailComplex2.headers"
                :items="detailComplex2.items"
                hide-actions
                class="elevation-1"
                >
                <template slot="items" slot-scope="props">          
                  <td class="text-sm-center">{{ props.item.driverType }}</td>
                  <td class="text-sm-center">{{ props.item.driverArea }}</td>
                  <td class="text-sm-center">
                    <div class="text-mixed">
                      <v-layout align-center class="ma-0">
                        <v-text-field
                                placeholder="개인사업자번호(운수번호)"
                                v-model="props.item.businessNumber"
                        ></v-text-field>
                        <v-btn color="warning" small dark @click="changeDriverBusinessNumber(props.item)">수정</v-btn>
                      </v-layout>
                    </div>
                  </td>
                  <td class="text-sm-center">{{ props.item.bankAccount != null ? props.item.bankAccount.bankName + ' ' + props.item.bankAccount.accountNumber + ' ' + props.item.bankAccount.accountHolder : '-' }}</td>
                  <td class="text-sm-center">
                    <v-btn color="primary" small dark @click="openDialogPicture(props.item.id)">보기</v-btn>
                  </td>
                  <td class="text-sm-center">
                    <v-btn color="primary" small dark @click="showThumbnailModal(props.item.id)">보기</v-btn>
                  </td>
                  <td class="text-sm-center">
                    <v-btn color="primary" small dark @click="openDialogLicense(props.item)">보기</v-btn>
                  </td>
                </template>
              </v-data-table>
              <v-divider></v-divider>
              <v-data-table
                      :headers="detailComplex3.headers"
                      :items="detailComplex3.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">
                    <v-text-field
                            placeholder="차량 번호"
                            v-model="props.item.taxiNum"
                    ></v-text-field>
                  </td>
                  <td class="text-sm-center">
                    <v-text-field
                            placeholder="차량 모델명"
                            v-model="props.item.carModelName"
                    ></v-text-field>
                  </td>
                  <td class="text-sm-center">
                    <v-btn color="warning" small dark @click="changeTaxiInfo(props.item)">수정</v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-list>

            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">이용 이력 (탑승 이력 및 결제 내역)</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="driverUsagesComplex.headers"
                :items="driverUsagesComplex.items"
                :pagination.sync="driverUsagesComplex.pagination"
                :rows-per-page-items="[5,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.endLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.carNum + ' ' + props.item.carModelName }}</td>
                  <td class="text-sm-center">{{ props.item.totalFee }}</td>
                </template>
              </v-data-table>
            </v-list>
            
            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">피신고 이력</v-toolbar-title>
                <v-spacer></v-spacer>
                <div>
                  누적 신고 횟수 : {{ totalBlameCount }}
                </div>
              </v-toolbar>
              <v-data-table
                :headers="blamesComplex.headers"
                :items="blamesComplex.items"
                :pagination.sync="blamesComplex.pagination"
                :rows-per-page-items="[5,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.endLocationName }}</td>
                  <td class="text-sm-center" @click="openReportDetail(props.item.relation, props.item.reportUserId)"><a>{{ (props.item.relation.split("_")[0] === 'D' ? '기사' : '승객') + ' ' + props.item.reportUserId }}</a></td>
                  <td class="text-sm-center">{{ props.item.type }}</td>
                </template>
              </v-data-table>
            </v-list>
          </v-card>
        </v-flex>

        <v-dialog v-model="license.dialog" scrollable max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">자격증</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="min-height: 465px">
              <img
                      alt="등록된 사진이 없습니다"
                      :src="licenseData"
                      width="469px"
              />
            </v-card-text>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                          label="자격증번호"
                          name="driverLicenseNumber"
                          placeholder="자격증번호 입력"
                          v-model="formModel.driverLicense.driverLicenseNumber"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap v-if="formModel.driverLicense.isDisplayCompanyField">
                <v-flex xs12>
                  <v-text-field
                          label="회사명"
                          name="companyName"
                          placeholder="회사명 입력"
                          v-model="formModel.driverLicense.companyName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="changeDriverLicenseNumberAndCompanyName()">Save</v-btn>
              <v-btn color="blue darken-1" flat @click.native="license.dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="picture.dialog" scrollable max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">본인 사진</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="min-height: 465px;">
              <img
                      alt="등록된 사진이 없습니다"
                      :src="pictureData"
                      width="469px"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click.native="picture.dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <ModalDriverImageThumbnail></ModalDriverImageThumbnail>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/state';
const _helpers = require('../../../node_modules/vuetify/es5/util/helpers');
const _slicedToArray = require('../../../mock/sliceToArray');
import ModalDriverImageThumbnail from '../../components/modal/modal-driver-image-thumbnail';


export default {
  components: {
    VWidget, ModalDriverImageThumbnail
  },
  data () {
    return {
      detailComplex: {
        headers: [
          {
            text: '기사 회원 고유번호',
            value: 'id',
            sortable: false,
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            sortable: false,
            align: 'center'
          },
          {
            text: '생년월일',
            value: 'birthDay',
            sortable: false,
            align: 'center'
          },
          {
            text: '성별',
            value: 'gender',
            sortable: false,
            align: 'center'
          },
          {
            text: '휴대전화번호',
            value: 'phoneNumber',
            sortable: false,
            align: 'center'
          },
          {
            text: '사용 상태',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '이용횟수',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '총 이용 금액',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '가입일',
            value: 'regDate',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      detailComplex2: {
        headers: [
          {
            text: '영업 종류',
            value: 'driverType',
            sortable: false,
            align: 'center'
          },
          {
            text: '영업 지역',
            value: 'driverArea',
            sortable: false,
            align: 'center'
          },
          {
            text: '개인사업자번호(운수사번)',
            value: 'businessNumber',
            sortable: false,
            align: 'center'
          },
          {
            text: '계좌 정보',
            value: 'bankAccount',
            sortable: false,
            align: 'center'
          },
          {
            text: '기사사진조회',
            value: '',
            sortable: false,
            align: 'center'
          },
          {
            text: '기사사진조회(썸네일)',
            value: '',
            sortable: false,
            align: 'center'
          },
          {
            text: '자격증사진조회',
            value: '',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      detailComplex3: {
        headers: [
          {
            text: '차량 번호',
            value: 'taxiNum',
            sortable: false,
            align: 'center'
          },
          {
            text: '차량 모델명',
            value: 'carModelName',
            sortable: false,
            align: 'center'
          },
          {
            text: '',
            value: '',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      driverUsagesComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '날짜',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '출발지',
            value: 'startLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '도착지',
            value: 'endLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '택시정보',
            value: 'carNum',
            sortable: false,
            align: 'center'
          },
          // {
          //   text: '메이트 정보',
          //   value: 'mateId',
          //   sortable: false,
          //   align: 'center'
          // },
          {
            text: '금액',
            value: 'totalFee',
            sortable: false,
            align: 'center'
          },
          // {
          //   text: '결제이력',
          //   value: 'billingHistoryId',
          //   sortable: false,
          //   align: 'center'
          // },
          // {
          //   text: '쿠폰이력',
          //   value: 'couponHistoryId',
          //   sortable: false,
          //   align: 'center'
          // },
        ],
        items: []
      },
      blamesComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '날짜',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '출발지',
            value: 'startLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '도착지',
            value: 'endLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '신고자',
            value: 'reportUserId',
            sortable: false,
            align: 'center'
          },
          {
            text: '신고타입',
            value: 'type',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      state: State,
      totalBlameCount: 0,
      picture: {
        dialog: false
      },
      license: {
        dialog: false
      },
      pictureData: '',
      licenseData: '',
      formModel: {
        driverLicense: {
          id: '',
          driverLicenseNumber: '',
          companyName: '',
          isDisplayCompanyField: false,
          curItem: null
        }
      },
    };
  },
  watch: {
    '$route.params' () {
      this.banbanCreated();
    }
  },
  mounted () {
    
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const prameters = {
        method: 'searchDriverDetails',
        'id': this.$route.params.id
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.callbackDetail(data);
          if (data.driver != null) {
            this.detailComplex.items = [data.driver];
            this.detailComplex2.items = [data.driver];

            if(data.driver.taxi) {
              this.detailComplex3.items = [data.driver.taxi];
            }
          }
          this.driverUsagesComplex.items = data.driverUsages;
          this.blamesComplex.items = data.blames;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    callbackDetail (data) {
      /* 상세정보 세팅 */
      data.driver.usageCount = data.driverUsages.length;
      data.driver.totalFee = 0;
      for (let i = 0; i < data.driverUsages.length; i++) {
        data.driver.totalFee += data.driverUsages[i].totalFee;
      }
      if (data.driver.state === 'WITHDRAWAL') {
        data.driver.deleteDate = data.driver.modDate;
      } else {
        data.driver.deleteDate = '-';
      }
      data.driver.bankAccount = data.bankAccount;

      /* 피신고 세팅 */
      this.totalBlameCount = 0;
      for (let i = 0; i < data.blames.length; i++) {
        if (data.blames[i].state === 'APPROVED') {
          this.totalBlameCount += 1;
        }
      }
    },
    changeDetail (id) {
      this.$router.push('/member/driverMemberDetail/' + id);
    },
    openReportDetail (relation, reportUserId) {
      if (relation.split('_')[0] === 'D') {
        this.$router.push('/member/driverMemberDetail/' + reportUserId);
      }
      else {
        this.$router.push('/member/passengerMemberDetail/' + reportUserId);
      }
    },
    openDialogPicture (id) {
      if(this.pictureData == '') {
        this.pictureData = apiHost.adminApiHost + '/attach/view/DRIVER_PICTURE/' + id + '?v' + Math.random();
      }
      this.picture.dialog = true;
    },
    openDialogLicense (item) {
      this.formModel.driverLicense.id = item.id;
      this.formModel.driverLicense.driverLicenseNumber = item.driverLicenseNumber;
      this.formModel.driverLicense.companyName = item.companyName;
      this.formModel.driverLicense.curItem = item;
      this.formModel.driverLicense.isDisplayCompanyField = item.driverType === 'COMPANY' ? true : false;

      if(this.licenseData == '') {
        this.licenseData = apiHost.adminApiHost + '/attach/view/DRIVER_LICENSE/' + this.formModel.driverLicense.id + '?v' + Math.random();
      }
      this.license.dialog = true;
    },
    changeDriverLicenseNumberAndCompanyName () {
      let driverLicenseNumber = this.formModel.driverLicense.driverLicenseNumber;
      let companyName = this.formModel.driverLicense.companyName;

      if(!driverLicenseNumber) {
        alert('자격증번호를 정확하게 입력해 주세요.');
        return;
      } else if(this.formModel.driverLicense.isDisplayCompanyField && !companyName ) {
        alert('회사명을 정확하게 입력해 주세요.');
        return;
      }

      const parameters = {
        method: 'changeDriverLicenseNumberAndCompanyName',
        'id': this.formModel.driverLicense.id,
        'driverLicenseNumber': driverLicenseNumber,
        'companyName': companyName
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          this.formModel.driverLicense.curItem.driverLicenseNumber = driverLicenseNumber;
          this.formModel.driverLicense.curItem.companyName = companyName;
          this.license.dialog = false;
          top.getApp.progress.dialog = false;

          alert('저장되었습니다.');
        });
    },
    showThumbnailModal (id) {
      this.$modal.show('modal-driver-image-thumbnail', {driverId : id});
    },
    changeTaxiInfo (taxi) {
      if(!taxi.taxiNum || !taxi.carModelName) {
        alert('차량 정보를 정확하게 입력해 주세요.');
        return;
      }

      if(!confirm('차량 정보를 수정하시겠습니까?')) return;

      const parameters = {
        method: 'changeTaxiInfo',
        id: taxi.id,
        taxiNum: taxi.taxiNum,
        carModelName: taxi.carModelName
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;

          alert('수정되었습니다.');
        });
    },
    changeDriverBusinessNumber (driver) {
      if(!driver.businessNumber) {
        alert('개인사업자번호(운수번호)를 정확하게 입력해 주세요.');
        return;
      }

      if(!confirm('개인사업자번호(운수번호)를 수정하시겠습니까?')) return;

      const parameters = {
        method: 'changeDriverBusinessNumber',
        id: driver.id,
        businessNumber: driver.businessNumber,
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;

          alert('수정되었습니다.');
        });
    },
    changeDriverName (driver) {
      if(!driver.name) {
        alert('이름을 정확하게 입력해 주세요.');
        return;
      }

      if(!confirm('이름을 수정하시겠습니까?')) return;

      const parameters = {
        method: 'changeDriverName',
        id: driver.id,
        name: driver.name,
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;

          alert('수정되었습니다.');
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/member/DriverMemberDetail.vue